<ng-container *ngIf="showConfirmation">

    <div class="shadow-1 mx-1 my-3 p-2 border-round-xl">
        <div>
            <h2 class="my-1">
                Confermi di voler presentare questa candidatura?
            </h2>
        </div>
        <div class="grid w-full">
            <div class="col">
                <p-button label="Annulla" (onClick)="cancel()" [outlined]="true" severity="danger" icon="pi pi-times"></p-button>
            </div>
            <div class="col-fixed">
                <p-button label="Conferma" (onClick)="submit(confirming!)" [outlined]="true" icon="pi pi-check"></p-button>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="!showConfirmation">
    <ng-container *ngFor="let nomination of nominations">

        <div class="shadow-1 mx-1 my-3 p-2 border-round-xl">
            <div>
                <h2 class="my-1">
                    {{nomination.title}}
                </h2>
            </div>
            <div>
                <ng-container [ngSwitch]="nomination.submitted?.status">
                    <div>
                        <div *ngSwitchCase="NominationStatus.ACCEPTED">
                            <p-tag severity="success"><span class="text-xl">Candidatura spontanea accettata</span></p-tag>
                        </div>
                        <div *ngSwitchCase="NominationStatus.CANCELLED">
                            <p-tag severity="info"><span class="text-xl">Candidatura spontanea cancellata come da richiesta</span></p-tag>
                        </div>
                        <div *ngSwitchCase="NominationStatus.NOT_REQUESTED">
                            <p-button label="Candidati" icon="pi pi-megaphone" severity="success" (onClick)="showConfirm(nomination)"></p-button>
                        </div>
                        <div *ngSwitchCase="NominationStatus.PENDING">
                            <p-tag severity="warning"><span class="text-xl">Candidatura spontanea in attesa di aprovazione</span></p-tag>
                            <p>
                                La sua richiesta verrà gestita entro le prossime 48 ore.
                            </p>
                            <p>
                                Se si desidera annullare la propria candidatura occorre comunicarlo tramite mail a: <strong>pistoia@faisa-cisal.org</strong>.
                            </p>
                        </div>
                        <div *ngSwitchCase="NominationStatus.REQUESTED_ANOTHER">
                            <p-tag severity="info"><span class="text-xl">Candidatura presentata per un'altra posizione</span></p-tag>
                        </div>
                        <div *ngSwitchCase="NominationStatus.REJECTED">
                            <p-tag severity="danger"><span class="text-xl">Candidatura spontanea rifiutata per mancanza dei requisiti</span></p-tag>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="nominations.length === 0 && loaded">
        <div class="flex w-full h-full align-items-center justify-content-center align-content-center">
            <div class="flex flex-wrap no-votes shadow-2 m-3 p-5 border-blue-400 border-2 border-round-xl">
                <div class="w-full flex justify-content-center"><h2 class="text-blue-500 m-0">Al momento non è possibile effettuare alcuna candidatura</h2></div>
            </div>
        </div>
    </ng-container>
</ng-container>